import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';

import './PendingCommissions.scss';

import { formatAmountInCurrency } from '../../helpers/formatting';

class PendingCommissions extends Component {
  static propTypes = {
    selectedBrand: PropTypes.object,
    setSelectedBrand: PropTypes.func.isRequired,
    selectedCommissions: PropTypes.array.isRequired,
    setSelectedCommissions: PropTypes.func.isRequired,
    updateCommission: PropTypes.func.isRequired,
    loadCommissionsForBrand: PropTypes.func.isRequired,
    account: PropTypes.object,
    user: PropTypes.object,
    brands: PropTypes.array.isRequired,
    commissions: PropTypes.array.isRequired,
    isLoadingCommissions: PropTypes.bool.isRequired,
    clearSelectedState: PropTypes.func.isRequired
  };

  isCommissionSelected = commission => !!_.find(this.props.selectedCommissions, c => c.id === commission.id);
  selectCommission = commission => {
    const isSelected = this.isCommissionSelected(commission);
    this.props.setSelectedCommissions(
      isSelected ? _.filter(this.props.selectedCommissions, c => c.id !== commission.id) : [...this.props.selectedCommissions, commission]
    );
  };

  selectBrand = brand => {
    const isSelected = this.props.selectedBrand?.id === brand?.id;

    if (!isSelected) {
      // selecting, load commissions for brand
      this.props.loadCommissionsForBrand(brand.id);
    } else {
      // unselecting, clear selections
      this.props.clearSelectedState();
    }

    this.props.setSelectedBrand(isSelected ? null : brand);
    this.props.setSelectedCommissions([]);
  };

  getBrandForCommission = commission => _.find(this.props.brands, brand => brand.id === commission.Brand_id);
  getInvoiceForCommission = commission => _.find(this.props.invoices, invoice => invoice.id === commission.Invoice_id);

  isCommissionLocked = commission => {
    const daysAgo = Math.floor((Date.now() - new Date(commission.transaction_date).getTime()) / 1000 / 60 / 60 / 24);
    return daysAgo >= (this.props.selectedBrand?.returnWindowLength || 30);
  };

  render() {
    const { brands, selectedBrand, account, commissions, isLoadingCommissions } = this.props;

    // For quick lookups

    return (
      <div className='pending-commissions-outer-container'>
        <div>
          <h1>Unpaid Commissions</h1>
          <div className='pending-commission-accordion accordion'>
            {_.map(brands, brand => {
              const isSelected = selectedBrand?.id === brand.id;
              const locked = _.filter(commissions, this.isCommissionLocked);
              return (
                <div key={brand.id} className='section'>
                  <div
                    className={classnames('header', { selected: isSelected, faded: selectedBrand && !isSelected })}
                    onClick={() => this.selectBrand(brand)}
                  >
                    <div>
                      {brand.name} -{' '}
                      {isSelected && (
                        <span className='small'>
                          {isLoadingCommissions ? (
                            <span>Loading commissions...</span>
                          ) : (
                            <span>
                              {locked.length} Locked, {commissions.length - locked.length} Pending
                            </span>
                          )}
                        </span>
                      )}
                    </div>
                    <div className='icons'>
                      {brand?.stripeCustomerId && <div className='stripe-icon'>STRIPE</div>}
                      <FontAwesomeIcon icon={isSelected ? faChevronUp : faChevronDown}></FontAwesomeIcon>
                    </div>
                  </div>
                  {isSelected && (
                    <div className='body'>
                      {!account && !isLoadingCommissions && (
                        <div className='row warning'>
                          <div className='cell'>This brand does not have an associated payment account.</div>
                        </div>
                      )}
                      <div className='row header'>
                        <div onClick={() => this.props.setSelectedCommissions(locked)} className='cell small'>
                          [ all ]
                        </div>
                        <div className='cell'>Date</div>
                        <div className='cell'>Order ID</div>
                        <div className='cell'>Order</div>
                        <div className='cell'>Commission</div>
                        <div className='cell'>Order USD</div>
                        <div className='cell'>Commission USD</div>
                        <div className='cell'>Code</div>
                        <div className='cell'>Status</div>
                      </div>
                      {_.map(_.orderBy(commissions, 'transaction_date'), (commission, idx) => {
                        const isSelected = this.isCommissionSelected(commission);
                        const {
                          order_id,
                          currency,
                          order_amount,
                          order_amount_usd,
                          commission_amount,
                          commission_amount_usd,
                          transaction_date,
                          isCancelled,
                          code
                        } = commission;
                        const isLocked = this.isCommissionLocked(commission);
                        return (
                          <div key={idx} className='row'>
                            <div
                              className={classnames('cell toggle small', { selected: isSelected })}
                              onClick={() => this.selectCommission(commission)}
                            >
                              {isSelected ? '[✓]' : '[ ]'}
                            </div>
                            <div className='cell'>{moment(transaction_date).format('MMMM Do')}</div>
                            <div className='cell'>{order_id}</div>
                            <div className='cell'>{formatAmountInCurrency(order_amount, currency)}</div>
                            <div className='cell'>{formatAmountInCurrency(commission_amount, currency)}</div>
                            <div className='cell'>${order_amount_usd.toFixed(2)}</div>
                            <div className='cell'>${commission_amount_usd.toFixed(2)}</div>
                            <div className='cell'>{code ? code : '-'}</div>
                            <div
                              onClick={() => {
                                const cancel = window.confirm(`Do you want to ${isCancelled ? 'un-cancel' : 'cancel'} this order?`);
                                cancel && this.props.updateCommission(commission, { isCancelled: !isCancelled });
                              }}
                              className='cell'
                            >
                              {isCancelled ? 'Cancelled' : isLocked ? 'Locked' : 'Pending'}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default PendingCommissions;
